/** "Recently used" bookmark strip on the dashboard. */
import { useMutation, useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import { Bookmark, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export function RecentBookmarks() {
  const recent = useQuery(api.items.recent, { limit: 8 });
  const touch = useMutation(api.items.touch);

  if (recent !== undefined && recent.length === 0) return null;

  return (
    <Card>
      <CardHeader className="pb-3 flex-row items-center justify-between space-y-0">
        <CardTitle className="text-base flex items-center gap-2">
          <Bookmark className="w-4 h-4" />
          Recently used
        </CardTitle>
        <Button asChild size="sm" variant="ghost">
          <Link to="/bookmarks">All bookmarks</Link>
        </Button>
      </CardHeader>
      <CardContent>
        {recent === undefined ? (
          <p className="text-sm text-muted-foreground">Loading…</p>
        ) : (
          <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-4">
            {recent.map((item) => (
              <a
                key={item._id}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  // Fire and forget — never block opening the link.
                  touch({ id: item._id }).catch(() => {});
                }}
                className="flex items-center gap-2 rounded-lg border border-border p-2.5 hover:border-primary/50 transition-colors min-w-0"
              >
                <ExternalLink className="w-3.5 h-3.5 shrink-0 text-muted-foreground" />
                <span className="text-sm truncate">{item.name}</span>
              </a>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
